




































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { StudentSubjectRow, StudentSheet } from "../../modules/student/SheetArchiveList"


export interface Data {
  studentSubjectRows: StudentSubjectRow[]
  reportNos: number[]
  examReportNos: number[]
  supplementaryExamReportNos: number[]
  StudentSheetStatusEnum: Readonly<{Answering: number; SelfScoring: number; Scoring: number; Failure: number; Pass: number;}>
  errors: string[]
}

interface DisplayColumn {
  key: string
  kind: "report" | "exam" | "supplementaryExam"
  label: string
  reportNo: number
  sourceIndex: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    /******************************
     * 画面データ
     ******************************/

    const state = reactive<Data>({
      studentSubjectRows: [],
      reportNos: [],
      examReportNos: [],
      supplementaryExamReportNos: [],
      StudentSheetStatusEnum: Common.StudentSheetStatusEnum,
      errors: [],
    });

    /******************************
     * 一覧の表示列を種別順に生成
     ******************************/

    const displayColumns = computed<DisplayColumn[]>(() => [
      ...state.reportNos.map((reportNo, sourceIndex) => ({
        key: `report-${reportNo}-${sourceIndex}`,
        kind: "report" as const,
        label: "レポート",
        reportNo,
        sourceIndex,
      })),
      ...state.examReportNos.map((reportNo, sourceIndex) => ({
        key: `exam-${reportNo}-${sourceIndex}`,
        kind: "exam" as const,
        label: "試験",
        reportNo,
        sourceIndex,
      })),
      ...state.supplementaryExamReportNos.map((reportNo, sourceIndex) => ({
        key: `supplementary-exam-${reportNo}-${sourceIndex}`,
        kind: "supplementaryExam" as const,
        label: "追試験",
        reportNo,
        sourceIndex,
      })),
    ]);

    /******************************
     * 表示列に対応する答案と解答用紙を取得
     ******************************/

    const studentSheetFor = (row: StudentSubjectRow, column: DisplayColumn) => {
      if(column.kind == "exam"){
        return row.examStudentSheets[column.sourceIndex];
      }
      if(column.kind == "supplementaryExam"){
        return row.supplementaryExamStudentSheets[column.sourceIndex];
      }
      return row.studentSheets[column.sourceIndex];
    };

    const baseSheetFor = (row: StudentSubjectRow, column: DisplayColumn) => {
      if(column.kind == "exam"){
        return row.examBaseSheets[column.sourceIndex];
      }
      if(column.kind == "supplementaryExam"){
        return row.supplementaryExamBaseSheets[column.sourceIndex];
      }
      return row.baseSheets[column.sourceIndex];
    };

    /******************************
     * 試験・追試験のハイフン表示判定
     ******************************/

    const isExamResultEmpty = (row: StudentSubjectRow, column: DisplayColumn) => {
      if(column.kind == "report"){
        return false;
      }
      const studentSheet = studentSheetFor(row, column);
      return !studentSheet || (studentSheet.status != Common.StudentSheetStatusEnum.Failure && studentSheet.status != Common.StudentSheetStatusEnum.Pass);
    };

    /************************************************************
     * 採点結果PDF表示
     ************************************************************/

    const downloadResultPdf = async (student_sheet_id: number) => {

      if(context.root.$store.state.isMobile){
        const button = document.getElementById("link-question");
        if(button){
          button.click();
        }
      }else{
        context.root.$store.dispatch("showOverlay");
      
        await http.get(resultPdfUrl(student_sheet_id), {responseType: 'arraybuffer'}).then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.target = "_blank"
          a.click();
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });

        context.root.$store.dispatch("hideOverlay");
        }
    }

    const resultPdfUrl = (student_sheet_id: number) => {
      return `/api/student/student_sheet_archive_list/download_result_pdf/${student_sheet_id}`
    }

    /******************************
     * 結果プレビュー画面へ遷移
     ******************************/

     const goResultImagePreview = (student_sheet_id: number) => {
      setStudentSheetListDispSubjectCodes();
      context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/result_image_preview/${student_sheet_id}`).catch(err => {});
    }

    /******************************
     * 履修科目の表示状態保存
     ******************************/
    
     const setStudentSheetListDispSubjectCodes = () => {
      const subjectCodes = state.studentSubjectRows.filter(x => x.isDisp).map(x => x.studentSubject.subject_code);
      console.log(subjectCodes)
      context.root.$store.commit("setStudentSheetListDispSubjectCodes", subjectCodes);
    }

    /******************************
     * 初期表示
     ******************************/
    
    onMounted(async () => {

      if(!Common.studentSiteLoginCheck(context)){
        return;
      }

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      
      await http.get(`/api/student/student_sheet_archive_list?student_code=${context.root.$store.state.student_code}`).then(response => {
        state.studentSubjectRows = response.data.student_subject_rows.map((x: any) => new StudentSubjectRow(x));
        state.reportNos = response.data.report_nos || [];
        state.examReportNos = response.data.exam_report_nos || [];
        state.supplementaryExamReportNos = response.data.supplementary_exam_report_nos || [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      displayColumns,
      studentSheetFor,
      baseSheetFor,
      isExamResultEmpty,
      downloadResultPdf,
      resultPdfUrl,
      goResultImagePreview,
    }
  }
});
